import React, { useCallback } from 'react';
import {
  Avatar,
  Colors,
  Divider,
  Flex,
  HorizontalSpacing,
  IconChevronRight,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import { isNotNil } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';
import { useGoodsBasic } from '../../queries/useGoodsBasic';
import { useLogClickBrandHome } from '../MarketInfoBanner/hooks/useLogClickBrandHome';

/**
 * 상품상세 브랜드 정보 영역.
 * /goods/{sno}/basic API 의 goods.brand 를 표시한다. (네이티브 ProductDetailBrandInfoView 대응)
 * brand 가 없는 상품(brand: null)이면 렌더하지 않는다.
 */
export const BrandInfo: React.FC = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const { openDeeplink } = useOpenDeeplink();
  const logClickBrandHome = useLogClickBrandHome();

  const brand = goodsBasic?.brand;
  const marketName = goodsBasic?.market.name ?? '';

  const onPressRow = useCallback(() => {
    // native ProductDetailBrandCell 과 동일하게 TYPE='BRAND_INFORMATION' 으로 로깅.
    // (심플 배너 MarketInfoBanner 는 'SIMPLE'. DISPLAY_BRAND_HOME 은 화면당 1회라
    //  MarketInfoBanner 에서 이미 발화하므로 여기선 노출 로깅을 추가하지 않는다.)
    logClickBrandHome('BRAND_INFORMATION');
    if (isNotNil(brand?.deeplink)) {
      openDeeplink(brand.deeplink);
    }
  }, [brand?.deeplink, openDeeplink, logClickBrandHome]);

  if (!isNotNil(brand)) return null;

  return (
    <Flex>
      <Flex.Row
        alignItems={'center'}
        padding={{ vertical: 12, horizontal: 16 }}
        onPress={onPressRow}
      >
        {isNotNil(brand.image) ? (
          <Avatar uri={brand.image} size={36} />
        ) : (
          <Flex
            width={36}
            height={36}
            borderRadius={18}
            borderWidth={1}
            borderColor={'border_secondary'}
          />
        )}
        <HorizontalSpacing size={12} />
        <Flex flex={1} justifyContent={'center'}>
          <Flex.Row alignItems={'center'}>
            <Typography type={'subtitle3'}>{brand.name}</Typography>
            <HorizontalSpacing size={4} />
            <Flex
              borderWidth={1}
              borderColor={'border_blue_secondary'}
              borderRadius={4}
              padding={{ horizontal: 4, vertical: 2 }}
            >
              <Typography type={'body6'} color={'content_blue_primary'}>
                브랜드
              </Typography>
            </Flex>
          </Flex.Row>
          <VerticalSpacing size={4} />
          <Typography type={'body4'} color={'content_secondary'}>
            판매 마켓 : {marketName}
          </Typography>
        </Flex>
        <HorizontalSpacing size={12} />
        <IconChevronRight fill={Colors.content_secondary} size={16} />
      </Flex.Row>
      <Divider size={'medium'} />
    </Flex>
  );
};
